import { render } from "./EditInscription.vue?vue&type=template&id=581633ae&ts=true"
import script from "./EditInscription.vue?vue&type=script&lang=ts"
export * from "./EditInscription.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__